import React from 'react';
import { useSelector } from 'react-redux';

import  EUAcknowledgementPage  from '../../../components/Acknowledgement/acknowledgement';
import { selectTransmissionType } from '@EUForms/selectors';

const AcknowledgementPageAES = (props) => {
  const { euPdf, handleLegalAcknowledgement, loadShipment, translate, countryCheck ,version} = props;



     const transmissionType = useSelector(selectTransmissionType)
 

  return (
    <EUAcknowledgementPage transmissionType={transmissionType}{...props}/>
  );
};

export default AcknowledgementPageAES;
